import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productCategoryList: [],
  productCategoryAllFormList: [],
  productCategoryAllList: [],
  productCategoryDetail: [],
  loading: false,
  error: undefined,
};

const productCategorySlice = createSlice({
  name: "productCategory",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchProductCategoryList(state, action) {
      state.productCategoryList = action.payload;
      state.loading = false;
    },
    fetchProductCategoryAllList(state, action) {
      state.productCategoryAllList = action.payload;
      state.loading = false;
    },
    fetchProductCategoryAllFormList(state, action) {
      state.productCategoryAllFormList = action.payload;
      state.loading = false;
    },
    fetchClearProdcutCategoryFormList(state, action) {
      state.productCategoryAllFormList = [];
      state.loading = false;
    },
    fetchProductCategoryDetail(state, action) {
      state.productCategoryDetail = action.payload;
      state.loading = false;
    },
  },
});

export const productCategoryActions = productCategorySlice.actions;

export default productCategorySlice.reducer;
